<template>
    <div>
        <div class="content">
            <Header/>
            <v-container>
                <v-layout align-center justify-center>
                    <v-flex lg12 md12 sm12 xs12>
                        <v-row justify-center>
                            <v-col>
                                <p class="text-center">Your session has expired</p>
                            </v-col>
                        </v-row>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import Header from "../login/Header";
    import Footer from "../login/Footer";

    export default {
        name: "Unauthorized",
        components: {Header, Footer}
    }
</script>
